/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import NProgress from 'nprogress';
import Backbone from 'backbone';
import _ from 'lodash';

import Scaffold from '@/Scaffold';
import * as NavUtils from '@/util/NavUtils';
import { userHasRole } from '@/util/RoleUtils';

import GetInternalUserNotifications from '../services/GetInternalUserNotifications';
import SearchInProgressCustomerOrders from '../services/SearchInProgressCustomerOrders';
import GetInProgressAssessments from '../services/GetInProgressAssessments';
import GetInternalInProgressOrderPackages from '../services/GetInternalInProgressOrderPackages';
import GetInProgressAWPackages from '../services/GetInProgressAWPackages';
import IntDashboardPage from '../pages/IntDashboardPage';
import ErrorView from '../../common/views/ErrorView/ErrorView';

export default async function ShowIntDashboardPage() {
  NProgress.start();

  if (EXTERNAL) {
    showErrorView();
    return;
  }

  try {
    const isCRSUser = userHasRole('CRS');
    const isEPCUser = userHasRole('EPC');

    // Services used for EPC and CRS Dashboards
    const [
      notificationsAndApprovalsRes,
      inProgressOrderPackagesRes,
      inProgressOrdersRes,
      inProgressAssessmentsRes,
      inProgressAWPackagesRes
    ] = await Promise.all([
      GetInternalUserNotifications(),
      GetInternalInProgressOrderPackages(),
      isCRSUser ? SearchInProgressCustomerOrders() : null,
      isCRSUser ? GetInProgressAssessments() : null,
      isEPCUser ? GetInProgressAWPackages() : null
    ]);

    _.forEach(inProgressOrderPackagesRes.inProgressOrderPackages, (item) => {
      item.orderIds = _.split(item.orderIds, ',');
    });

    if (inProgressAWPackagesRes) {
      _.forEach(inProgressAWPackagesRes.inProgressAWPackages, (item) => {
        item.orderIds = _.split(item.orderIds, ',');
      });
    }
    const modelObj = {
      notificationsAndApprovals: notificationsAndApprovalsRes,
      inProgressOrderPackages: inProgressOrderPackagesRes.inProgressOrderPackages,
      inProgressOrders: inProgressOrdersRes?.orders,
      inProgressAssessments: inProgressAssessmentsRes?.inProgressAssessments,
      inProgressAWPackages: inProgressAWPackagesRes?.inProgressAWPackages
    };

    NavUtils.navigate('dashboard');
    Scaffold.getRegion('content').show(new IntDashboardPage({ model: new Backbone.Model(modelObj) }));
  } catch (err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the Internal Dashboard page.'
        })
      })
    );
  } finally {
    NProgress.done();
  }
}

function showErrorView() {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: 'Access Denied',
        errorDetails: 'Your account may not have permission to view the Internal Dashboard page.'
      })
    })
  );
  NProgress.done();
}
